// extracted by mini-css-extract-plugin
export default {"imageCardSlide":"image-card-slide-module--image-card-slide--f82ab","imageCard":"image-card-slide-module--image-card--bdcae"};